'use client'
import React, { useState, useCallback, useMemo } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import Button from 'src/components/era-package/forms/Button'; // you already use this in your project
import EditESLineModal from '../entry-form/edit/EditESLineModal';
import pathMap from 'src/paths/pathMap';

import {
  skuTemplate,
  lineItem,
  lineItemFee,
  misc,
  softwood,
  steel,
  aluminum,
  alcohol,
  optionsMap as esLineOptionsMap,
} from '../../fields/entry-summary-line'; // <-- same source as your current pages

const NAME = 'lineItems';


const CreateSKUMgmt = ({ history }) => {
  const [open, setOpen] = useState(true);
  const [isEditing] = useState(false);
  const [editingIndex] = useState(0);

  // Compose the same formFields array your existing flow uses
  const formFields = useMemo(
    () => [
      ...skuTemplate,
      ...lineItem,
      ...lineItemFee,
      ...misc,
      ...softwood,
      ...steel,
      ...aluminum,
      ...alcohol,
    ],
    []
  );

  // RHF context the modal expects
  const methods = useForm({
    defaultValues: {
      header: { abiTransId: null },          // the modal reads header.abiTransId
      [NAME]: [
        {
          id: null,
          esLine: 1,
          description: '',
          lineReference: '',
          invoiceNo: '',
          countryOfOrigin: '',
          goodsValue: 0,
          dutyAmtSum: 0,
          chargesAmt: 0,
          countryOfExport: '',
          dateOfExport: '',
          portOfLading: '',
          grossWeightKgs: 0,
          manufacturerSupplier: '',
          foreignExporter: '',
          deliveredTo: '',
          soldToId: '',
          includeMPFFee: false,
          includeHMFFee: false,
          tariffList: [],
          userFeeList: [],
          cargoEntityList: [],
          pgaList: [],
          // skutemplate-related fields so validations work if toggled
          saveSKUTemplate: false,
          skuReference: '',
          skuLookup: '',
        },
      ],
    },
    mode: 'onBlur',
  });

    const navigateToSkuList = useCallback(() => {
    history.push(pathMap.ABI_SKU_MGMT_LIST_VIEW);
  }, [history]);

  const handleClose = useCallback(() => {
    setOpen(false);
    navigateToSkuList();
  }, [navigateToSkuList]);
  const handleSave = useCallback(() => {}, []);
  const handleDelete = useCallback(() => {}, []);
  const handleRefreshData = useCallback(() => {
    // Optional: refresh your surrounding page state after save
  }, []);


    return (
    <FormProvider {...methods}>
      <EditESLineModal
        title="SKU Template"
        open={open}
        onClose={handleClose}
        onSave={handleSave}
        onDelete={handleDelete}
        handleRefreshData={handleRefreshData}
        fields={[]}                         
        formFields={formFields}             
        name={NAME}
        optionsMap={esLineOptionsMap ?? {}}
        initialData={methods.getValues(`${NAME}.${editingIndex}`)}
        isEditing={isEditing}
        index={editingIndex}
        initialSkuId={0}
       
        footerRender={({ isEditing, loading, onPrimary, onCancel /*, onDelete*/ }) => (
          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', width: '100%' }}>
            <Button variant="outlined" onClick={onCancel}>
              Close
            </Button>
            <Button
              onClick={onPrimary}
              variant="contained"
              title={isEditing ? 'Save changes' : 'Add this record'}
              disabled={loading}
            >
              {isEditing ? 'Save' : 'Add'}
            </Button>
            {/* If you also want Delete here:
            {isEditing && (
              <Button variant="outlined" color="error" onClick={onDelete}>
                Delete
              </Button>
            )} */}
          </div>
        )}
      />
    </FormProvider>
  );
};

export default CreateSKUMgmt;
